<template>
  <!--
      作者：gmshop
      时间：2020-06-25
      描述：插件中心-限时拼团
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="团队业绩" name="first" v-if="show_Performance == true"><Performance v-if="activeName == 'first'"></Performance></el-tab-pane>
      <el-tab-pane label="月度业绩结算单" name="second" v-if="show_Statement == true"><Statement v-if="activeName == 'second'"></Statement></el-tab-pane>
      <el-tab-pane label="总业绩结算" name="team" v-if="show_Team == true"><Team v-if="activeName == 'team'"></Team></el-tab-pane>
      <el-tab-pane label="基础设置" name="third" v-if="show_getSetting == true"><getSetting v-if="activeName == 'third'"></getSetting></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Performance from './performance/index';
import Statement from './statement/index';
import Team from './team/index';
import getSetting from './setting/getSetting.vue';
export default {
  components: {
    /*活动列表*/
    Performance,
    /*结算单*/
    Statement,
    /*总业绩结算*/
    Team,
    /*基础设置*/
    getSetting
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'first',
      /*权限检测*/
      show_Performance: false,
      show_Statement: false,
      show_Team: false,
      show_getSetting: false,
    };
  },
  created() {
    /*权限检测*/
    if(this.$filter.isAuth('/plus/groupaward/performance/index'))  this.show_Performance = true;
    if(this.$filter.isAuth('/plus/groupaward/statement/index'))  this.show_Statement = true;
    if(this.$filter.isAuth('/plus/groupaward/team/index'))  this.show_Team = true;
    if(this.$filter.isAuth('/plus/groupaward/setting/index'))  this.show_getSetting = true;
    
    /*默认值*/
    if(this.show_Performance == true){
      this.activeName = 'first';
    }else if(this.show_Statement == true){
      this.activeName = 'second';
    }else if(this.show_Team == true){
      this.activeName = 'team';
    }else if(this.show_getSetting == true){
      this.activeName = 'third';
    }

    let active_name = localStorage.getItem('activeName')
    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/index.vue